import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import bgImage from "../../assets/images/bg-img.jpg";
import axios from "axios";
import toast from "react-hot-toast";

const CreatedJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userID = searchParams.get("user_id");
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);

  // const fetchJobs = async () => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_KEY}/fetch_all_created_jobs?user_id=${userID}`, {
  //         headers: {
  //           "Cache-Control": "no-cache"
  //         },
  //       }
  //     );
  //     const data = await response.json();
  //     setJobs(data.candidate_applied_jobs || []);
  //   } catch (error) {
  //     console.error("Error fetching created jobs:", error);
  //     setJobs([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchJobs = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_KEY}/fetch_all_created_jobs?user_id=${userID}`,
        {
          cache: "no-cache", // Tells browser to not use cache
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      );
      const data = await response.json();
      setJobs(data.candidate_applied_jobs || []);
    } catch (error) {
      console.error("Error fetching created jobs:", error);
      setJobs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [userID]);

  const handleJobDelete = async (jobId) => {
    console.log("Delete Job ID:", jobId);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/update_job_status?jd_id=${jobId}`,
        { job_status: "Archived" },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("Job status updated successfully");
        fetchJobs();
      }
    } catch (error) {
      console.error("Error updating job status:", error);
    }
  };

  const handleAddJob = () => {
    navigate(`/create-position?user_id=${userID}`, {
      state: { from: "/created-jobs" },
    });
  };

  return (
    <div
      className="w-full min-h-[calc(100vh-96px)] pt-10 px-6 pb-20"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h2 className="text-xl font-bold text-white mb-6">Created Jobs :</h2>
      <div className="flex justify-end mb-4">
        <button
          onClick={handleAddJob}
          className="px-5 py-2 bg-blue-700 text-white rounded-lg shadow-md hover:bg-blue-800 transition flex items-center gap-2"
        >
          + Add New Job
        </button>
      </div>
      {loading ? (
        <p className="text-white">Loading...</p>
      ) : jobs.length === 0 ? (
        <p className="text-white">No jobs found.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {jobs.map((job) => (
            <div
              key={job.id}
              className="bg-white rounded-xl shadow-lg border border-gray-200 p-4 flex flex-col"
            >
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h3 className="text-md font-bold text-blue-700">
                    {job.job_title}
                  </h3>
                  <p className="text-xs text-gray-600">
                    <strong>ID:</strong> {job.id}
                  </p>
                </div>
                <div className="flex gap-2">
                  {/* <button
                    onClick={() => handleJobEdit(job)}
                    className="bg-blue-500 text-white text-xs px-2 py-1 rounded hover:bg-blue-600"
                  >
                    Edit
                  </button> */}
                  <button
                    onClick={() => {
                      setSelectedJobId(job.id);
                      setShowConfirm(true);
                    }}
                    className="bg-red-500 text-white text-xs px-2 py-1 rounded hover:bg-red-600"
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              {showConfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-10 flex justify-center items-center z-50">
                  <div className="bg-white p-6 rounded-lg shadow-lg text-center">
                    <p className="text-lg font-semibold mb-4">
                      Are you sure you want to archive this job?
                    </p>
                    <div className="flex justify-center gap-4">
                      <button
                        onClick={() => {
                          handleJobDelete(selectedJobId);
                          setShowConfirm(false);
                        }}
                        className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                      >
                        Yes
                      </button>
                      <button
                        onClick={() => setShowConfirm(false)}
                        className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="text-sm text-gray-700 mb-2">
                <strong>Experience:</strong> {job.min_experience}-
                {job.max_experience} yrs
              </div>

              <div className="text-sm text-gray-700 mb-2">
                <strong>Skills:</strong>{" "}
                {JSON.parse(job.required_skills).join(", ")}
              </div>

              <div className="text-sm text-gray-700 mb-2 overflow-y-auto max-h-24 pr-1">
                <strong>Description:</strong>
                <p className="text-xs text-gray-600 whitespace-pre-wrap mt-1">
                  {job.job_description}
                </p>
              </div>

              <div className="text-sm text-gray-800 mt-2 font-medium mb-1">
                Candidates:
              </div>
              <div className="flex flex-col gap-2 overflow-y-auto max-h-20 pr-1">
                {job.candidates.length === 0 ? (
                  <p className="text-xs text-gray-500">None applied yet.</p>
                ) : (
                  job.candidates.map((candidate, idx) => (
                    <div
                      key={idx}
                      className="bg-gray-100 rounded p-2 flex justify-between items-start"
                    >
                      <div className="text-xs text-gray-700">
                        <p className="font-semibold">
                          {candidate.first_name} {candidate.last_name} (#
                          {candidate.id})
                        </p>
                        <p>{candidate.email.replace("mailto:", "")}</p>
                        <p className="text-sm">
                          <span
                            className={`font-semibold ${
                              candidate.interview_status === "Completed"
                                ? "text-green-600"
                                : candidate.interview_status === "Pending"
                                ? "text-red-600"
                                : "text-yellow-600"
                            }`}
                          >
                            <span className="text-sm font-semibold text-gray-700">
                              Interview status :
                            </span>{" "}
                            {candidate.interview_status}
                          </span>
                        </p>
                        <p className="text-sm">
                          <span
                            className={`font-semibold ${
                              candidate.shortlist_status === "Yes"
                                ? "text-green-600"
                                : "text-red-600"
                            }`}
                          >
                            <span className="text-sm font-semibold text-gray-700">
                              Shortlist status :
                            </span>{" "}
                            {candidate.shortlist_status}
                          </span>
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CreatedJobs;
